export default __webpack_public_path__ + "static/media/favorites-elevatelavender-comp.8c71b2fb.png";